import React, { useState, useEffect } from 'react';
import { Dialog } from '@headlessui/react';
import { ExclamationCircleIcon } from '@heroicons/react/solid';
import { useAuth } from '../../Global/Context/AuthProvider';
import { useNavigate } from 'react-router-dom';
import { UseContextApp } from "../../Global/Context/appContext";

const ModalSessionTimeout = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { signOut } = useAuth();
  const navigate = useNavigate();
  const [{ user }] = UseContextApp();

  useEffect(() => {
    if (!user) {
      setIsModalOpen(false);
      return;
    }
    //cierra session en 1 hora
    /*const intervalId = setInterval(() => {      
      setIsModalOpen(true);
    }, 57 * 60 * 1000);*/
  
    //cierra session en 5 minutos
    const intervalId = setInterval(() => {      
      setIsModalOpen(true);
    }, 5 * 60 * 1000);

    return () => clearInterval(intervalId);
  }, [user]);

  useEffect(() => {
    if (isModalOpen) {
            
      const closeSessionTimeout = setTimeout(async () => {
        setIsModalOpen(false);
        await signOut();
        navigate('/cuenta/salir');
        window.location.reload();
      }, 3 * 60 * 1000);

      

      return () => clearTimeout(closeSessionTimeout);
    }
  }, [isModalOpen, signOut, navigate]);

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleLogout = async () => {
    await signOut();
    setIsModalOpen(false);
    navigate('/cuenta/salir');
    window.location.reload();
  };

  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isModalOpen]);

  return (
    <>
      <Dialog open={isModalOpen} onClose={handleCloseModal}>
        <Dialog.Overlay className="fixed inset-0 bg-gray-500 opacity-50" onClick={handleCloseModal} />

        <div className="fixed inset-0 flex items-center justify-center z-50">
          <Dialog.Panel className="bg-white rounded-lg p-6 max-w-sm w-full shadow-lg">
            <div className="flex items-center mb-4">
              <div className="bg-red-400 text-white rounded-full p-2 mr-4">
                <ExclamationCircleIcon className="h-6 w-6" />
              </div>
              <Dialog.Title className="text-xl font-bold">
                ¡Tu sesión está por expirar!
              </Dialog.Title>
            </div>

            <Dialog.Description className="mb-4">
              Si deseas mantenerte conectado, haz clic en "Continuar".
            </Dialog.Description>

            <div className="flex justify-end space-x-4">
              <button
                onClick={handleLogout}
                className="px-4 py-2 bg-red-500 text-white rounded-md border-none"
              >
                Cerrar sesión
              </button>

              <button
                onClick={handleCloseModal}
                className="px-4 py-2 bg-green-400 text-white rounded-md border-none"
              >
                Continuar
              </button>
            </div>
          </Dialog.Panel>
        </div>
      </Dialog>
    </>
  );
};

export default ModalSessionTimeout;
